var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmarkFilled = function SvgBookmarkFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M5 4.584C5 4.261 5.261 4 5.583 4h12.834c.322 0 .583.261.583.584v15.831c0 .47-.525.747-.912.483l-5.76-3.93a.58.58 0 0 0-.656 0l-5.76 3.93A.583.583 0 0 1 5 20.415z"
  })));
};
export default SvgBookmarkFilled;